import { Link, NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import { useAuth } from "../Utility/AuthContext";

export default function Layout({ children }) {
  const { user } = useAuth();
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="site-header">
        <Link className="brand" to="/" aria-label="Pick Your End home">
          <AutoStoriesOutlinedIcon />{" "}
          <span>
            Pick Your End<span className="brand-dot">.</span>
          </span>
        </Link>
        <nav aria-label="Main navigation">
          <NavLink to="/dashboard">The library</NavLink>
          {user?.isAdmin && <NavLink to="/admin">Review</NavLink>}
          {user ? (
            <>
              <NavLink to={`/profile/${encodeURIComponent(user.username)}`}>
                My stories
              </NavLink>
              <Button component={Link} to="/create" variant="contained">
                Write a story
              </Button>
            </>
          ) : (
            <>
              <NavLink to="/login">Sign in</NavLink>
              <Button component={Link} to="/register" variant="contained">
                Start writing
              </Button>
            </>
          )}
        </nav>
      </header>
      <main id="main" tabIndex="-1">
        {children}
      </main>
      <footer className="site-footer">
        <Link className="brand" to="/">
          Pick Your End.
        </Link>
        <span>A little imagination. A world of possibilities.</span>
        <Link to="/dashboard">Find your next adventure →</Link>
      </footer>
    </div>
  );
}
